import { styled, TableCell, TableRow, TextField } from '@mui/material';

export const InformationH2 = styled('h2')(({ theme }) => ({
  fontSize: '14px',
  color:
    theme.palette.mode === 'dark' ? theme.palette.text.secondary : '#000000',
  opacity: theme.palette.mode === 'dark' ? 1 : '60%',
  fontWeight: '400',
}));

export const InformationP = styled('p')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '16px;',
  margin: 0,
}));

export const InformationLocationH2 = styled('h2')(({ theme }) => ({
  fontSize: '12px',
  color:
    theme.palette.mode === 'dark' ? theme.palette.text.secondary : '#000000',
  opacity: theme.palette.mode === 'dark' ? 1 : '38%',
  fontWeight: '400',
}));

export const InformationChipStyle = {
  fontSize: '0.8125rem',
  color: 'text.primary',
  backgroundColor: 'action.selected',
  borderRadius: '16px',
} as const;

export const LocationList = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
});

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    opacity: '87%',
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.action.hover : '#FAFAFA',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const StyledTableCell = styled(TableCell)(() => ({
  fontWeight: '600',
}));

export const StyledFieldSet = styled('fieldset')(() => ({
  border: 0,
  padding: 0,
}));

export const StyledTextField = styled(TextField)(() => ({
  width: '100%',
}));
